import { BundleBuilderStoreMixinComponent } from '@theme/bundle-builder-mixin-store';

/**
 * @typedef {import('./bundle-builder-store.js').Product} Product
 * @typedef {import('./bundle-builder-store.js').Variant} Variant
 * @typedef {Record<string, import('./bundle-builder-mixin.js').BundleBuilderPropSpec>} BundleBuilderProps
*/


/**
 * @typedef {object} ProductCardRefs
 * @property {HTMLElement} price
 * @property {HTMLElement} soldOutStatus
 */

export class ProductCardComponent extends BundleBuilderStoreMixinComponent {
  /** @type {string[]} */
  requiredRefs = ['price', 'soldOutStatus'];

  /** @type {BundleBuilderProps} */
  props = {
    productId: {
      type: 'number',
      required: true,
      attributeName: 'data-product-id',
    },
  };

  /** @type {number} */
  productId;

  /** @type {Product|undefined} */
  product;

  connectedCallback() {
    super.connectedCallback();
    this.product = this.getters.getProduct(this.productId);
    this.#renderSoldOutState();
  }

  get itemOnBundle() {
    return this.state.items.find(item => item.productId === this.productId);
  }

  get price() {
    return this.itemOnBundle?.price ?? this.getters.getTierVariant(this.productId)?.price ?? 0;
  }

  get isSoldOut() {
    return this.getters.isProductCardSoldOut(this.productId);
  }

  onStateUpdate() {
    this.product = this.getters.getProduct(this.productId);
    this.#renderSoldOutState();
    this.renderObjectToHTML({
      price: this.getters.formatMoney(
        this.price
      ),
    });
  }

  #renderSoldOutState() {
    this.classList.toggle('is-sold-out', this.isSoldOut);
    /** @type {HTMLElement} */ (this.refs.soldOutStatus).hidden = !this.isSoldOut;
  }

}

if (!customElements.get('bundle-builder-product-card-component')) {
  customElements.define('bundle-builder-product-card-component', ProductCardComponent);
}